import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AppsService } from "src/app/shared/services/apps.service";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";

@Component({
  selector: "app-state-trips-dashboard",
  templateUrl: "./state-trips-dashboard.component.html",
  styleUrls: ["./state-trips-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StateTripsDashboardComponent implements OnInit {
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridTotals0: any[] = [
    {
      column: "tnt_dsply_nm",
      summaryType: "count",
      displayFormat: "Total: {0}",
    },
    { column: "ttl_vhcls", summaryType: "sum", displayFormat: "{0}" },
    { column: "trps_asgnd_vhcls", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "trps_not_asgnd_vhcls",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    { column: "rts_dfnd_vhcls", summaryType: "sum", displayFormat: "{0}" },
    { column: "rts_not_dfnd_vhcls", summaryType: "sum", displayFormat: "{0}" },
    { column: "def_trps", summaryType: "sum", displayFormat: "{0}" },
    { column: "trvl_trps", summaryType: "sum", displayFormat: "{0}" },
    { column: "nt_trvl_trps", summaryType: "sum", displayFormat: "{0}" },
    { column: "rts_dfnd", summaryType: "sum", displayFormat: "{0}" },
    { column: "trckd_rts", summaryType: "sum", displayFormat: "{0}" },
    { column: "rte_dvtd", summaryType: "sum", displayFormat: "{0}" },
  ];

  header_label = {
    name: "State Trips Dashboard",
  };

  showLdr = false;
  filters: boolean = true;
  clntDtls: any;
  tntLst: any = [];
  selectedtenant = 0;
  vendorList: any = [];
  selectedvndr = 0;
  userDtls: any;
  clap_in: number;
  ShowClap: boolean;
  showVndr: boolean;
  slctdDt: any;
  curDate: any;
  dateFormat = "dd-MM-yyyy";
  ttlTrpsCnt: any = [];
  ulbWiseData: any = [];
  totalUlbs: number = 0;
  trpCreatedUlbs: number = 0;
  trpNotCreatedUlbs: number = 0;
  rteDfndUlbs: number = 0;
  rteNotDfndUlbs: number = 0;

  // Vehicle-wise detail drilldown
  vhclWiseData: any = [];
  showVhclTable: boolean = false;
  vhclTableLdr: boolean = false;
  selectedCard: string = "";
  selectedCardLabel: string = "";
  isTripLevel: boolean = false;

  // ULB card filter
  selectedUlbCard: string = "";
  allUlbWiseData: any = [];

  // Go Back to urban dashboard
  fromUrbanDashboard: boolean = false;

  disabledDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, new Date()) > 0;
  };

  constructor(
    public apiServ: AppsService,
    private router: Router,
    public TransfereService: TransfereService
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    }
  }

  ngOnInit() {
    this.fromUrbanDashboard =
      this.TransfereService.getLoclData("from_urban_dashboard") === true;
    this.TransfereService.setLoclData("from_urban_dashboard", false);
    this.slctdDt = new Date();
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.get_totalTripsCount();
    this.getUlbWiseTrips();
    this.getVendors();
  }

  onChange(result: Date): void {
    this.curDate = moment(result).format("YYYY-MM-DD");
    this.get_totalTripsCount();
    this.getUlbWiseTrips();
  }

  get_totalTripsCount() {
    this.ttlTrpsCnt = [];
    this.showLdr = true;
    let postData: any = {
      dt: this.curDate,
    };
    if (this.selectedtenant > 0) {
      postData.slctd_tnt = this.selectedtenant;
    }
    let rte = `dashboard/enterprise/ttlTrips/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.ttlTrpsCnt = res["data"];
        if (this.ttlTrpsCnt && this.ttlTrpsCnt.length > 0) {
          this.ttlTrpsCnt[0].ttl_vhcls =
            (this.ttlTrpsCnt[0].trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].trps_not_asgnd_vhcls || 0);
          this.ttlTrpsCnt[0].primary_ttl_vhcls =
            (this.ttlTrpsCnt[0].primary_trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].primary_trps_not_asgnd_vhcls || 0);
          this.ttlTrpsCnt[0].secondary_ttl_vhcls =
            (this.ttlTrpsCnt[0].secondary_trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].secondary_trps_not_asgnd_vhcls || 0);
          // Auto-select Primary - Trips Vehicles Defined by default (no scroll on load)
          this.onCardClick(
            1,
            "trips_vhcls_defined",
            "Primary - Trips Vehicles Defined",
            false
          );
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
        this.showLdr = false;
      }
    );
  }

  getUlbWiseTrips() {
    this.ulbWiseData = [];
    this.allUlbWiseData = [];
    this.selectedUlbCard = "";
    this.showLdr = true;
    let postData: any = {
      dt: this.curDate,
    };
    if (this.selectedtenant > 0) {
      postData.slctd_tnt = this.selectedtenant;
    }
    let rte = `dashboard/enterprise/ulbWiseTrips/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.allUlbWiseData = res["data"] || [];
        this.ulbWiseData = [...this.allUlbWiseData];
        this.totalUlbs = this.allUlbWiseData.length;
        this.trpCreatedUlbs = this.allUlbWiseData.filter(
          (u) => (u.def_trps || 0) > 0
        ).length;
        this.trpNotCreatedUlbs = this.totalUlbs - this.trpCreatedUlbs;
        this.rteDfndUlbs = this.allUlbWiseData.filter(
          (u) => (u.rts_dfnd || 0) > 0
        ).length;
        this.rteNotDfndUlbs = this.totalUlbs - this.rteDfndUlbs;
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
        this.showLdr = false;
      }
    );
  }

  ontntSelect(value) {
    this.selectedtenant = value;
    this.selectedvndr = 0;
    this.getVendors();
    this.get_totalTripsCount();
    this.getUlbWiseTrips();
  }

  onvndrSelect(value) {
    this.selectedvndr = value;
    this.get_totalTripsCount();
    this.getUlbWiseTrips();
  }

  getVendors() {
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      this.apiServ
        .get(`billing/vendors/list/${this.selectedvndr}/byId`)
        .subscribe(
          (res) => {
            if (res["status"] == 200) {
              this.vendorList = res["data"];
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
    } else {
      this.apiServ
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
              }
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    }
  }

  onCardClick(
    trpTypeId: number,
    category: string,
    label: string,
    scroll: boolean = true
  ) {
    const key = `${trpTypeId}_${category}`;
    if (this.selectedCard === key) {
      this.showVhclTable = false;
      this.selectedCard = "";
      this.selectedCardLabel = "";
      this.vhclWiseData = [];
      return;
    }
    this.selectedCard = key;
    this.selectedCardLabel = label;
    // Trip-level categories show individual trip rows; vehicle-level show aggregated
    const vhclLevelCategories = [
      "all_vhcls",
      "trips_vhcls_defined",
      "trips_vhcls_not_defined",
      "routes_vhcls_defined",
      "routes_vhcls_not_defined",
      "single_trip",
      "multiple_trips",
    ];
    this.isTripLevel = !vhclLevelCategories.includes(category);
    this.getVhclWiseTrips(trpTypeId, category, scroll);
  }

  getVhclWiseTrips(
    trpTypeId: number,
    category: string,
    scroll: boolean = true
  ) {
    this.vhclWiseData = [];
    this.vhclTableLdr = true;
    this.showVhclTable = true;
    let postData: any = {
      dt: this.curDate,
      trp_type_id: trpTypeId,
      category: category,
    };
    if (this.selectedtenant > 0) {
      postData.slctd_tnt = this.selectedtenant;
    }
    let rte = `dashboard/enterprise/vhclWiseTrips/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        this.vhclWiseData = res["data"];
        this.vhclTableLdr = false;
        if (scroll) {
          this.scrollToElement("vhclGridTable");
        }
      },
      (err) => {
        console.log(err);
        this.vhclTableLdr = false;
      }
    );
  }

  onUlbCardClick(card: string) {
    if (this.selectedUlbCard === card) {
      this.selectedUlbCard = "";
      this.ulbWiseData = [...this.allUlbWiseData];
      return;
    }
    this.selectedUlbCard = card;
    let filtered = [];
    if (card === "ulb_total") {
      filtered = [...this.allUlbWiseData];
    } else if (card === "ulb_trip_defined") {
      filtered = this.allUlbWiseData.filter((u) => (u.def_trps || 0) > 0);
    } else if (card === "ulb_trip_not_defined") {
      filtered = this.allUlbWiseData.filter((u) => (u.def_trps || 0) === 0);
    } else if (card === "ulb_route_defined") {
      filtered = this.allUlbWiseData.filter((u) => (u.rts_dfnd || 0) > 0);
    } else if (card === "ulb_route_not_defined") {
      filtered = this.allUlbWiseData.filter(
        (u) => (u.def_trps || 0) > 0 && (u.rts_dfnd || 0) === 0
      );
    }
    this.ulbWiseData = filtered.map((row, idx) => ({ ...row, sno: idx + 1 }));
    this.scrollToElement("ulbGridSection");
  }

  onUlbClick(row: any) {
    this.goToRouteDeviation(row.tnt_id);
  }

  goToRouteDeviation(tntId) {
    this.TransfereService.setLoclData("slctd_tnt_frm_state", tntId);
    this.router.navigate([`internal/dashboard/routeDeviation-dashboard`]);
  }

  scrollToElement(id: string) {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 400);
  }

  goBackToDashboard() {
    this.router.navigate([`internal/dashboard/urban-dashboard`]);
  }

  navigateTo(page: string) {
    this.router.navigate([`internal/dashboard/${page}`]);
  }

  fltrs() {
    this.filters = !this.filters;
  }
}
